import { useRequest } from '~/repositories'

/** Returns a one-way hashed version of an email address for use in analytics events. */
export const postEncryptEmail = (payload: any) => {
	return useRequest('post', `/v1/utils/encrypt/`, payload)
}

export default {
	postEncryptEmail,
}
